export const uriWithCulture = (uri, culture) => {
    // rewrite uri with culture from state
    const url = new URL (uri)
    const params = new URLSearchParams(url.search);
    params.set('cul', culture);
    return `${url.origin}${url.pathname}?${params.toString()}`
 }